// src/App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import TopHeader from "./components/TopHeader/TopHeader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HeroSearch from "./components/HeroSearch";
import CategoriesSection from "./components/CategoriesSection";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Properties from "./components/Properties/Properties";
import Agents from "./components/Agents/Agents";
import Blog from "./components/Blog/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import PropertyListPage from "./pages/PropertyListPage/PropertyListPage";
import PropertyDetailsPage from "./pages/PropertyDetailsPage/PropertyDetailsPage";

function App() {
  const location = useLocation();

  const isSearchPage = location.pathname === "/properties";
  return (
    <div className="App">
      {/* Hide TopHeader only on search page */}
      {!isSearchPage && <TopHeader />}
      <Header />
      <div className="whatsapp-float">
        <a
          href="https://wa.me/9067161025"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
      <main className="main-content">
        <Routes>
          {/* HOME PAGE */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <HeroSearch />
                <About />
                <CategoriesSection />
                <Testimonials />
                <Properties />
                <Agents />
                <Blog />
                <Contact />
              </>
            }
          />

          {/* PROPERTY SEARCH PAGE */}
          <Route path="/properties" element={<PropertyListPage />} />
          <Route path="/property/:id" element={<PropertyDetailsPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
